import React from 'react';
import EditorField from './_EditorField';
import DataBindingPanel from '../DataBindingPanel';

export default function ChartEditor({ section, dispatch, appId }) {
  const cfg = section.section_config || {};
  const update = patch => dispatch({ type: 'UPDATE_SECTION_CONFIG', clientId: section._clientId, patch });
  const updateBinding = patch => dispatch({ type: 'UPDATE_DATA_BINDING', clientId: section._clientId, patch });

  return (
    <div>
      <DataBindingPanel appId={appId} binding={section.data_binding} onChange={updateBinding} />
      <div style={{ marginTop: 14 }}>
        <EditorField label="Chart Title (optional)">
          <input className="form-control form-control-sm" value={cfg.title || ''} onChange={e => update({ title: e.target.value })} />
        </EditorField>
        <EditorField label="">
          <div className="form-check">
            <input className="form-check-input" type="checkbox" id="showLegend" checked={cfg.show_legend !== false} onChange={e => update({ show_legend: e.target.checked })} />
            <label className="form-check-label" htmlFor="showLegend" style={{ fontSize: 13 }}>Show legend</label>
          </div>
        </EditorField>
      </div>
    </div>
  );
}
